<app-menu></app-menu>
<div class="dash-page">
  <div class="page-guide">CONTROLPS / INTRANET</div>

  <div class="tab-toolbar">
    <div class="cp-tabs intranet-tabs">
      <button mat-stroked-button type="button" [class.active]="activeMainTab === 'dashboard'" (click)="setActiveMainTab('dashboard')">
        <mat-icon>dashboard</mat-icon>
        Dashboard
      </button>
      <button mat-stroked-button type="button" [class.active]="activeMainTab === 'posts'" (click)="setActiveMainTab('posts')">
        <mat-icon>campaign</mat-icon>
        Postagens
      </button>
      <button mat-stroked-button type="button" [class.active]="activeMainTab === 'documents'" (click)="setActiveMainTab('documents')">
        <mat-icon>description</mat-icon>
        Documentos
      </button>
      <button mat-stroked-button type="button" [class.active]="activeMainTab === 'questions'" (click)="setActiveMainTab('questions')">
        <mat-icon>quiz</mat-icon>
        Questionários
      </button>
    </div>

    <div class="tab-toolbar__actions">
      <button
        mat-raised-button
        color="primary"
        class="quick-actions-btn"
        type="button"
        [matMenuTriggerFor]="intranetNovoMenu">
        <mat-icon>add</mat-icon>
        <span class="quick-actions-btn__label">NOVO</span>
      </button>

      <mat-menu
        #intranetNovoMenu="matMenu"
        class="novo-menu-panel"
        xPosition="before"
        yPosition="below"
        [hasBackdrop]="true"
        backdropClass="cdk-overlay-transparent-backdrop">
        <button mat-menu-item type="button" (click)="openNewPost()">
          Nova postagem
        </button>
        <button mat-menu-item type="button" (click)="openDispatchModal()">
          Novo documento
        </button>
        <button mat-menu-item type="button" (click)="openQuestionDispatchModal()">
          Novo questionário
        </button>
      </mat-menu>
    </div>
  </div>

  <section class="intranet-v2-kpis" *ngIf="activeMainTab === 'dashboard'">
    <article class="intranet-v2-kpi-card">
      <div class="intranet-v2-kpi-card__head">
        <span>Publicações (período)</span>
        <mat-icon>campaign</mat-icon>
      </div>
      <strong>{{ intranetNumber(intranetDashboardKpis.postsPeriod) }}</strong>
      <small>Média mensal: {{ intranetDecimal(intranetInsights.avgPostsPerDay) }}</small>
    </article>

    <article class="intranet-v2-kpi-card">
      <div class="intranet-v2-kpi-card__head">
        <span>Total de curtidas</span>
        <mat-icon>favorite</mat-icon>
      </div>
      <strong>{{ intranetNumber(intranetDashboardKpis.likesPeriod) }}</strong>
      <small>Média mensal: {{ intranetDecimal(intranetInsights.avgLikesPerDay) }}</small>
    </article>

    <article class="intranet-v2-kpi-card">
      <div class="intranet-v2-kpi-card__head">
        <span>Total de comentários</span>
        <mat-icon>chat_bubble</mat-icon>
      </div>
      <strong>{{ intranetNumber(intranetDashboardKpis.commentsPeriod) }}</strong>
      <small>Média mensal: {{ intranetDecimal(intranetInsights.avgCommentsPerDay) }}</small>
    </article>

    <article class="intranet-v2-kpi-card">
      <div class="intranet-v2-kpi-card__head">
        <span>Engajamento médio</span>
        <mat-icon>insights</mat-icon>
      </div>
      <strong>{{ intranetDecimal(intranetDashboardKpis.avgInteractionsPerPost) }}</strong>
      <small>Interações por publicação</small>
    </article>
  </section>

  <section class="intranet-v2-layout" *ngIf="activeMainTab === 'dashboard'">
    <article class="card intranet-v2-card intranet-v2-card--evolution">
      <header class="intranet-v2-card__head">
        <h3>Likes e comentários por mês</h3>
        <div class="intranet-period-toggle">
          <button type="button" class="intranet-period-btn" [class.active]="dashboardPeriodMonths === 3" (click)="setDashboardPeriod(3)">3m</button>
          <button type="button" class="intranet-period-btn" [class.active]="dashboardPeriodMonths === 6" (click)="setDashboardPeriod(6)">6m</button>
          <button type="button" class="intranet-period-btn" [class.active]="dashboardPeriodMonths === 12" (click)="setDashboardPeriod(12)">12m</button>
        </div>
      </header>
      <div class="intranet-v2-line-chart" *ngIf="intranetDailySeries.length">
        <svg viewBox="0 0 640 230" preserveAspectRatio="none">
          <polyline class="grid-line" points="36,18 36,192 616,192"></polyline>
          <ng-container *ngFor="let tick of intranetLineYAxisTicks">
            <line class="grid-line-h" x1="36" x2="616" [attr.y1]="tick.y" [attr.y2]="tick.y"></line>
            <text class="y-axis-label" x="30" [attr.y]="tick.y + 3" text-anchor="end">{{ tick.label }}</text>
          </ng-container>
          <line
            class="line-average"
            x1="36"
            x2="616"
            [attr.y1]="intranetLineYByValue(intranetInteractionsAveragePerDay)"
            [attr.y2]="intranetLineYByValue(intranetInteractionsAveragePerDay)">
            <title>Média no período: {{ intranetInteractionsAveragePerDayLabel }} interações/mês</title>
          </line>
          <text
            class="line-average-label"
            x="612"
            [attr.y]="intranetLineYByValue(intranetInteractionsAveragePerDay) - 6"
            text-anchor="end">
            Média {{ intranetInteractionsAveragePerDayLabel }}/mês
          </text>

          <polyline
            class="line line-primary"
            [attr.points]="intranetLinePointList(intranetInteractionSeriesValues)">
          </polyline>
          <polyline
            class="line line-secondary"
            [attr.points]="intranetLinePointList(intranetInteractionTrendSeriesValues)">
          </polyline>

          <ng-container *ngFor="let point of intranetLineDots(intranetInteractionSeriesValues)">
            <circle
              class="dot dot-primary"
              [attr.cx]="point.x"
              [attr.cy]="point.y"
              r="5"
              (mouseenter)="intranetLinePointEnter($event, point, 'interactions')"
              (mousemove)="intranetLinePointMove($event, point, 'interactions')"
              (mouseleave)="intranetLinePointLeave()">
            </circle>
          </ng-container>
          <ng-container *ngFor="let point of intranetLineDots(intranetInteractionTrendSeriesValues)">
            <circle
              class="dot dot-secondary"
              [attr.cx]="point.x"
              [attr.cy]="point.y"
              r="4.2"
              (mouseenter)="intranetLinePointEnter($event, point, 'trend')"
              (mousemove)="intranetLinePointMove($event, point, 'trend')"
              (mouseleave)="intranetLinePointLeave()">
            </circle>
          </ng-container>
        </svg>
        <div
          class="intranet-v2-chart-tooltip"
          *ngIf="intranetLineTooltip.visible"
          [style.left.px]="intranetLineTooltip.x"
          [style.top.px]="intranetLineTooltip.y">
          <strong>{{ intranetLineTooltip.title }}</strong>
          <small>{{ intranetLineTooltip.value }}</small>
        </div>
        <div class="intranet-v2-line-chart__labels" [style.gridTemplateColumns]="'repeat(' + intranetDailySeries.length + ', 1fr)'">
          <span *ngFor="let item of intranetDailySeries">{{ item.label }}</span>
        </div>
      </div>
      <div class="intranet-v2-legend intranet-v2-line-legend">
        <span><i class="legend-dot legend-dot--primary"></i>Interações</span>
        <span><i class="legend-dot legend-dot--secondary"></i>Tendência</span>
        <span><i class="legend-line legend-line--average"></i>Média {{ intranetInteractionsAveragePerDayLabel }}/mês</span>
      </div>
    </article>

    <article class="card intranet-v2-card intranet-v2-card--types">
      <header class="intranet-v2-card__head">
        <h3>Tipo de post</h3>
        <span>{{ intranetTypeRows.length }} tipo(s)</span>
      </header>
      <div class="intranet-v2-type-donut-wrap" *ngIf="intranetTypeRows.length; else emptyTypes">
        <div class="intranet-v2-donut-wrap">
          <div class="intranet-v2-donut" [style.background]="intranetTypeDonutStyle">
            <div class="intranet-v2-donut__inner">
              <strong>{{ intranetNumber(intranetDashboardKpis.postsPeriod) }}</strong>
              <small>posts</small>
            </div>
          </div>
        </div>
        <div class="intranet-v2-status-bars">
          <div class="intranet-v2-status-row" *ngFor="let row of intranetTypeRows">
            <div class="intranet-v2-status-row__head">
              <span>{{ row.label }}</span>
              <strong>{{ intranetNumber(row.count) }} · {{ row.percent }}%</strong>
            </div>
            <div class="mini-bar">
              <div class="mini-bar__fill" [style.width.%]="row.percent" [style.background]="row.color"></div>
            </div>
          </div>
          <div class="empty" *ngIf="!intranetTypeRows.length">
            Sem postagens no período.
          </div>
        </div>
      </div>
      <ng-template #emptyTypes>
        <div class="empty">Sem postagens no período.</div>
      </ng-template>
    </article>

    <article class="card intranet-v2-card intranet-v2-card--top">
      <header class="intranet-v2-card__head">
        <h3>Top postagens por engajamento</h3>
        <span>Likes + comentários</span>
      </header>
      <div class="intranet-v2-top-list">
        <div class="intranet-v2-top-item" *ngFor="let item of intranetTopPosts">
          <div class="intranet-v2-top-item__meta">
            <strong>{{ item.title }}</strong>
            <small>{{ item.author }} · {{ item.dateLabel }}</small>
          </div>
          <div class="intranet-v2-top-item__score">
            <strong>{{ intranetNumber(item.score) }}</strong>
            <small>{{ intranetNumber(item.likes) }} likes · {{ intranetNumber(item.comments) }} comentários</small>
          </div>
        </div>
        <div class="empty" *ngIf="!intranetTopPosts.length">Sem dados no período selecionado.</div>
      </div>
    </article>

    <article class="card intranet-v2-card intranet-v2-card--insights">
      <header class="intranet-v2-card__head">
        <h3>Resumo da intranet</h3>
        <span>Indicadores rápidos</span>
      </header>
      <div class="intranet-v2-insights-grid">
        <div>
          <span>Interações no período</span>
          <strong>{{ intranetNumber(intranetDashboardKpis.interactionsPeriod) }}</strong>
        </div>
        <div>
          <span>Visualizações no período</span>
          <strong>{{ intranetNumber(intranetInsights.totalViewsPeriod) }}</strong>
        </div>
        <div>
          <span>Likes por mês</span>
          <strong>{{ intranetDecimal(intranetInsights.avgLikesPerDay) }}</strong>
        </div>
        <div>
          <span>Comentários por mês</span>
          <strong>{{ intranetDecimal(intranetInsights.avgCommentsPerDay) }}</strong>
        </div>
      </div>
    </article>
  </section>

  <section class="pending-docs-section" *ngIf="activeMainTab === 'documents'">
    <header>
      <div>
        <h2>Documentos pendentes</h2>
        <p>ControlSign · pendências para o seu usuário.</p>
      </div>
      <span class="pending-count">{{ pendingDocuments.length }}</span>
    </header>

    <p class="pending-state" *ngIf="loadingPendingDocs">Carregando documentos...</p>
    <p class="pending-state pending-state--error" *ngIf="!loadingPendingDocs && pendingDocsError">{{ pendingDocsError }}</p>
    <p class="pending-state" *ngIf="!loadingPendingDocs && !pendingDocsError && !pendingDocuments.length">Nenhum documento pendente.</p>

    <div class="pending-list" *ngIf="!loadingPendingDocs && pendingDocuments.length">
      <article class="pending-item" *ngFor="let doc of pendingDocuments | slice:0:4">
        <div class="pending-item__icon">
          <mat-icon>description</mat-icon>
        </div>
        <div class="pending-item__meta">
          <strong>{{ doc.title }}</strong>
          <small>{{ doc.sent_at | date:'dd/MM/yy, HH:mm' }}</small>
        </div>
      </article>
    </div>

    <button type="button" class="pending-open" (click)="openPendingDocuments()" *ngIf="pendingDocuments.length">
      Abrir pendências no feed
    </button>
  </section>

  <section class="posts-table-section" *ngIf="activeMainTab === 'posts'">
    <header>
      <div>
        <h2>{{ 'INTRANET_DASH.POSTS.TITLE' | translate }}</h2>
        <p>{{ 'INTRANET_DASH.POSTS.SUBTITLE' | translate }}</p>
      </div>
      <button type="button" (click)="loadPosts()" [disabled]="loadingPosts">
        {{ loadingPosts ? ('INTRANET_DASH.POSTS.UPDATING' | translate) : ('INTRANET_DASH.POSTS.UPDATE_LIST' | translate) }}
      </button>
    </header>

    <div class="filters-row">
      <label>
        {{ 'INTRANET_DASH.FILTERS.DATE' | translate }}
        <input type="date" [(ngModel)]="filters.date" (change)="onFiltersChanged()">
      </label>
      <label>
        {{ 'INTRANET_DASH.FILTERS.STATUS' | translate }}
        <select [(ngModel)]="filters.status" (change)="onFiltersChanged()">
          <option *ngFor="let option of statusOptions" [value]="option.value">{{ option.labelKey | translate }}</option>
        </select>
      </label>
      <label>
        {{ 'INTRANET_DASH.FILTERS.AUTHOR' | translate }}
        <input type="text" [placeholder]="'INTRANET_DASH.FILTERS.AUTHOR_PLACEHOLDER' | translate" [(ngModel)]="filters.author" (input)="onFiltersChanged()">
      </label>
    </div>

    <div class="table-wrapper" *ngIf="!postsError">
      <table class="posts-table" *ngIf="pagedPosts.length; else emptyState">
        <thead>
          <tr>
            <th>{{ 'INTRANET_DASH.TABLE.POST' | translate }}</th>
            <th>{{ 'INTRANET_DASH.TABLE.STATUS' | translate }}</th>
            <th>{{ 'INTRANET_DASH.TABLE.AUTHOR' | translate }}</th>
            <th>{{ 'INTRANET_DASH.TABLE.TYPE' | translate }}</th>
            <th>{{ 'INTRANET_DASH.TABLE.LIKES' | translate }}</th>
            <th>{{ 'INTRANET_DASH.TABLE.COMMENTS' | translate }}</th>
            <th>{{ 'INTRANET_DASH.TABLE.VIEWS' | translate }}</th>
            <th>{{ 'INTRANET_DASH.TABLE.ACTIONS' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let post of pagedPosts">
            <td class="post-meta">
              <div class="thumb" *ngIf="thumbnailUrl(post); else placeholderThumb">
                <img [src]="thumbnailUrl(post)" [alt]="'INTRANET_DASH.TABLE.POST_PREVIEW' | translate">
              </div>
              <ng-template #placeholderThumb>
                <div class="thumb placeholder">
                  <mat-icon>{{ isVideo(post) ? 'videocam' : 'image' }}</mat-icon>
                </div>
              </ng-template>
              <div class="meta-info">
                <p class="post-date">{{ post.posted_at | date:'dd/MM/yy, HH:mm' }}</p>
                <small *ngIf="post.show_popup" class="popup-flag">Popup</small>
                <small *ngIf="post.scheduled_at">{{ 'INTRANET_DASH.TABLE.SCHEDULED' | translate }}: {{ post.scheduled_at | date:'dd/MM/yy, HH:mm' }}</small>
                <small *ngIf="postExcerpt(post)">{{ postExcerpt(post) }}</small>
              </div>
            </td>
            <td><span class="status-chip" [ngClass]="post.status">{{ statusLabel(post.status) }}</span></td>
            <td>{{ post.author_name || ('INTRANET_DASH.TABLE.EMPTY' | translate) }}</td>
            <td>{{ post.post_type | titlecase }}</td>
            <td class="metric">{{ post.likes_count || 0 }}</td>
            <td class="metric">{{ post.comments_count || 0 }}</td>
            <td class="metric">{{ post.views || 0 }}</td>
            <td class="actions-cell">
              <div class="action-menu">
                <button type="button" (click)="onActionMenuToggle($event, post.id)">
                  {{ 'INTRANET_DASH.TABLE.ACTIONS' | translate }}
                  <mat-icon>expand_more</mat-icon>
                </button>
                <div class="menu-panel" *ngIf="actionMenuOpen === post.id" (click)="$event.stopPropagation()">
                  <button type="button" (click)="editPost(post)" *ngIf="canEdit(post)">{{ 'INTRANET_DASH.ACTIONS.EDIT_POST' | translate }}</button>
                  <button type="button" (click)="toggleVisibility(post)">
                    {{ post.status === 'hidden' ? ('INTRANET_DASH.ACTIONS.PUBLISH' | translate) : ('INTRANET_DASH.ACTIONS.HIDE' | translate) }}
                  </button>
                  <button type="button" *ngIf="post.show_popup" (click)="togglePopupHighlight(post, false)">{{ 'INTRANET_DASH.ACTIONS.POPUP_DISABLE' | translate }}</button>
                  <button type="button" *ngIf="!post.show_popup" (click)="togglePopupHighlight(post, true)">{{ 'INTRANET_DASH.ACTIONS.POPUP_ENABLE' | translate }}</button>
                  <mat-slide-toggle [ngModel]="post.allow_comments" (ngModelChange)="toggleComments(post, $event)" [disabled]="post.show_popup">
                    {{ 'INTRANET_DASH.ACTIONS.COMMENTS_ENABLED' | translate }}
                  </mat-slide-toggle>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <ng-template #emptyState>
        <p class="empty">{{ 'INTRANET_DASH.EMPTY' | translate }}</p>
      </ng-template>
    </div>
    <div class="pagination" *ngIf="filteredPosts.length > pageSize">
      <button type="button" (click)="changePage(-1)" [disabled]="currentPage === 1">{{ 'PAGINATION.PREV' | translate }}</button>
      <span>{{ 'PAGINATION.PAGE' | translate:{ current: currentPage, total: totalPages } }}</span>
      <button type="button" (click)="changePage(1)" [disabled]="currentPage === totalPages">{{ 'PAGINATION.NEXT' | translate }}</button>
    </div>
    <p class="list-error" *ngIf="postsError">{{ postsError }}</p>
  </section>

  <section class="question-shortcut-section" *ngIf="activeMainTab === 'questions'">
    <header>
      <div>
        <h2>Questionários da intranet</h2>
        <p>Dispare questionários habilitados para os colaboradores.</p>
      </div>
      <button type="button" class="primary-action" (click)="openQuestionDispatchModal()">
        Disparar questionário
      </button>
    </header>

    <p class="pending-state" *ngIf="questionDispatchesLoading">Carregando questionários enviados...</p>
    <p class="pending-state pending-state--error" *ngIf="!questionDispatchesLoading && questionDispatchesError">{{ questionDispatchesError }}</p>
    <p class="pending-state" *ngIf="!questionDispatchesLoading && !questionDispatchesError && !questionDispatches.length">
      Nenhum questionário enviado ainda.
    </p>

    <div class="question-dispatch-list" *ngIf="!questionDispatchesLoading && questionDispatches.length">
      <article class="question-dispatch-item" *ngFor="let item of questionDispatches">
        <div class="question-dispatch-item__meta">
          <strong>{{ item.survey_title }}</strong>
          <small>
            Tipo: {{ item.sent_type }} ·
            Enviado por: {{ item.sent_by_name || 'Usuário' }} ·
            {{ item.sent_at ? (item.sent_at | date:'dd/MM/yy, HH:mm') : ('ID #' + item.id) }}
          </small>
        </div>
        <div class="question-dispatch-item__stats">
          <span>Total: {{ item.total_recipients || 0 }}</span>
          <span>Pendentes: {{ item.pending_recipients || 0 }}</span>
          <span>Concluídos: {{ item.done_recipients || 0 }}</span>
        </div>
      </article>
    </div>

    <div class="question-dispatch-pagination" *ngIf="questionDispatchesTotalPages > 1">
      <button type="button" (click)="changeQuestionDispatchPage(-1)" [disabled]="questionDispatchesPage <= 1">Anterior</button>
      <span>{{ questionDispatchesPage }} / {{ questionDispatchesTotalPages }}</span>
      <button type="button" (click)="changeQuestionDispatchPage(1)" [disabled]="questionDispatchesPage >= questionDispatchesTotalPages">Próxima</button>
    </div>
  </section>

  <div class="modal-backdrop" *ngIf="documentDispatchOpen" (click)="closeDispatchModal()"></div>
  <section class="modal-card cp-modal-fixed-height intranet-document-dispatch-modal" *ngIf="documentDispatchOpen" (click)="$event.stopPropagation()">
    <header class="modal-header">
      <div>
        <h2>{{ 'INTRANET_DASH.DISPATCH.TITLE' | translate }}</h2>
        <small>{{ 'CONTROLSIGN.LIST_DESC' | translate }}</small>
      </div>
      <button class="icon" type="button" (click)="closeDispatchModal()">
        <mat-icon>close</mat-icon>
      </button>
    </header>

    <form class="cp-modal-body" (submit)="$event.preventDefault()">
      <div class="cp-modal-scroll">
        <section class="panel dispatch-section">
          <h3>{{ 'INTRANET_DASH.DISPATCH.DOC_SECTION' | translate }}</h3>
          <div class="source-options">
            <label>
              <input type="radio" name="docSource" value="existing" [checked]="documentSource === 'existing'" (change)="onDocumentSourceChange('existing')">
              {{ 'INTRANET_DASH.DISPATCH.USE_EXISTING' | translate }}
            </label>
            <label>
              <input type="radio" name="docSource" value="upload" [checked]="documentSource === 'upload'" (change)="onDocumentSourceChange('upload')">
              {{ 'INTRANET_DASH.DISPATCH.UPLOAD_NEW' | translate }}
            </label>
          </div>

          <div *ngIf="documentSource === 'existing'">
            <div class="filter-field compact">
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>{{ 'INTRANET_DASH.DISPATCH.SEARCH_DOC' | translate }}</mat-label>
                <mat-icon matPrefix>search</mat-icon>
                <input matInput type="text" name="dispatch_document_search" [(ngModel)]="documentSearch">
              </mat-form-field>
            </div>
            <div class="docs-list" *ngIf="!loadingDocuments; else docsLoading">
              <label class="doc-item" *ngFor="let doc of filteredDocuments">
                <input type="radio" name="dispatch_selected_document" [value]="doc.id" [(ngModel)]="selectedDocumentId">
                <div>
                  <strong>{{ doc.title }}</strong>
                  <small>{{ doc.document_type | titlecase }} · {{ doc.created_at | date:'dd/MM/yy' }}</small>
                </div>
              </label>
              <p class="empty" *ngIf="!filteredDocuments.length">{{ 'INTRANET_DASH.DISPATCH.DOC_EMPTY' | translate }}</p>
            </div>
            <ng-template #docsLoading>
              <p class="list-status">{{ 'INTRANET_DASH.DISPATCH.DOC_LOADING' | translate }}</p>
            </ng-template>
          </div>

          <div class="doc-toggles">
            <mat-slide-toggle [(ngModel)]="newDocumentForm.is_public_document" name="dispatch_is_public_document" (ngModelChange)="onPublicDocumentToggle()">
              Documento público
            </mat-slide-toggle>
          </div>

          <div class="upload-block" *ngIf="documentSource === 'upload'">
            <div class="upload-grid cp-form-row">
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>{{ 'INTRANET_DASH.DISPATCH.TITLE_LABEL' | translate }}</mat-label>
                <input matInput type="text" [(ngModel)]="newDocumentForm.title" name="dispatch_title" [placeholder]="'INTRANET_DASH.DISPATCH.TITLE_PLACEHOLDER' | translate">
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>{{ 'INTRANET_DASH.DISPATCH.TYPE_LABEL' | translate }}</mat-label>
                <select matNativeControl [(ngModel)]="newDocumentForm.document_type" name="dispatch_type">
                  <option *ngFor="let option of documentTypeOptions" [value]="option.value">{{ option.labelKey | translate }}</option>
                </select>
              </mat-form-field>
            </div>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field full-width">
              <mat-label>{{ 'INTRANET_DASH.DISPATCH.DESC_LABEL' | translate }}</mat-label>
              <textarea
                matInput
                rows="3"
                [(ngModel)]="newDocumentForm.description"
                name="dispatch_description"
                [placeholder]="'INTRANET_DASH.DISPATCH.DESC_PLACEHOLDER' | translate"></textarea>
            </mat-form-field>
            <div class="dropzone document-drop" (click)="documentFileInput.click()">
              <input type="file" accept=".pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.txt" #documentFileInput (change)="onDocumentFileChange($event)">
              <ng-container *ngIf="documentFileName; else newDocPlaceholder">
                <mat-icon>description</mat-icon>
                <p>{{ documentFileName }}</p>
                <small>{{ 'INTRANET_DASH.DISPATCH.FILE_REPLACE' | translate }}</small>
              </ng-container>
              <ng-template #newDocPlaceholder>
                <mat-icon>cloud_upload</mat-icon>
                <p>{{ 'INTRANET_DASH.DISPATCH.FILE_HINT' | translate }}</p>
              </ng-template>
            </div>
            <small class="upload-hint">Formatos permitidos: PDF, DOC, DOCX, PPT, PPTX, XLS, XLSX e TXT · limite de {{ maxDocumentFileSizeMb }}MB</small>
            <p class="feedback dispatch-feedback error" *ngIf="documentFileError">{{ documentFileError }}</p>

            <div class="doc-toggles">
              <mat-slide-toggle [(ngModel)]="newDocumentForm.require_read" name="dispatch_require_read" [disabled]="newDocumentForm.is_public_document">{{ 'INTRANET_DASH.DISPATCH.REQUIRE_READ' | translate }}</mat-slide-toggle>
              <mat-slide-toggle [(ngModel)]="newDocumentForm.require_accept" name="dispatch_require_accept" [disabled]="newDocumentForm.is_public_document">{{ 'INTRANET_DASH.DISPATCH.REQUIRE_ACCEPT' | translate }}</mat-slide-toggle>
              <mat-slide-toggle [(ngModel)]="newDocumentForm.require_agreement" name="dispatch_require_agreement" [disabled]="newDocumentForm.is_public_document">{{ 'INTRANET_DASH.DISPATCH.REQUIRE_AGREEMENT' | translate }}</mat-slide-toggle>
              <mat-slide-toggle [(ngModel)]="newDocumentForm.require_signature" name="dispatch_require_signature" [disabled]="newDocumentForm.is_public_document">{{ 'INTRANET_DASH.DISPATCH.REQUIRE_SIGNATURE' | translate }}</mat-slide-toggle>
              <mat-slide-toggle [(ngModel)]="newDocumentForm.require_selfie" name="dispatch_require_selfie" [disabled]="newDocumentForm.is_public_document">{{ 'INTRANET_DASH.DISPATCH.REQUIRE_SELFIE' | translate }}</mat-slide-toggle>
              <mat-slide-toggle [(ngModel)]="newDocumentForm.require_geolocation" name="dispatch_require_geolocation" [disabled]="newDocumentForm.is_public_document">{{ 'INTRANET_DASH.DISPATCH.REQUIRE_GEOLOCATION' | translate }}</mat-slide-toggle>
            </div>
          </div>
        </section>

        <section class="panel dispatch-section" *ngIf="!newDocumentForm.is_public_document">
          <h3>{{ 'INTRANET_DASH.DISPATCH.RECIPIENTS' | translate }}</h3>
          <div class="source-options">
            <label>
              <input type="radio" name="audience" value="ALL" [checked]="dispatchAudience === 'ALL_USERS'" (change)="toggleRecipientMode('ALL_USERS')">
              {{ 'INTRANET_DASH.DISPATCH.RECIPIENTS_ALL' | translate }}
            </label>
            <label>
              <input type="radio" name="audience" value="SPEC" [checked]="dispatchAudience === 'SPECIFIC_USERS'" (change)="toggleRecipientMode('SPECIFIC_USERS')">
              {{ 'INTRANET_DASH.DISPATCH.RECIPIENTS_SPECIFIC' | translate }}
            </label>
          </div>

          <div *ngIf="dispatchAudience === 'SPECIFIC_USERS'">
            <div class="filter-field compact">
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>{{ 'INTRANET_DASH.DISPATCH.USER_SEARCH' | translate }}</mat-label>
                <mat-icon matPrefix>search</mat-icon>
                <input matInput type="text" name="dispatch_user_search" [(ngModel)]="userSearch">
              </mat-form-field>
            </div>
            <div class="users-list" *ngIf="!loadingRecipients; else usersLoading">
              <label class="user-item" *ngFor="let user of filteredTenantUsers">
                <input type="checkbox" [checked]="selectedUserIds.has(user.id)" (change)="toggleRecipientSelection(user.id)">
                <div>
                  <strong>{{ user.name || ('INTRANET_DASH.USER_FALLBACK' | translate) }}</strong>
                  <small>{{ user.email }}</small>
                </div>
              </label>
              <p class="empty" *ngIf="!filteredTenantUsers.length">{{ 'INTRANET_DASH.DISPATCH.USERS_EMPTY' | translate }}</p>
            </div>
            <ng-template #usersLoading>
              <p class="list-status">{{ 'INTRANET_DASH.DISPATCH.USERS_LOADING' | translate }}</p>
            </ng-template>
          </div>
        </section>

        <div class="feedback dispatch-feedback" *ngIf="dispatchFeedback" [class.error]="dispatchFeedback.includes('não') || dispatchFeedback.includes('Selecione') || dispatchFeedback.includes('Erro')">
          {{ dispatchFeedback }}
        </div>
      </div>

      <footer class="entry-footer">
        <button type="button" mat-stroked-button (click)="closeDispatchModal()">{{ 'COMMON.CANCEL' | translate }}</button>
        <button type="button" mat-raised-button color="primary" (click)="dispatchDocument()" [disabled]="savingDispatch">
          {{ savingDispatch ? ('COMMON.SENDING' | translate) : (newDocumentForm.is_public_document ? 'Publicar documento' : ('INTRANET_DASH.DISPATCH.SEND' | translate)) }}
        </button>
      </footer>
    </form>
  </section>

  <div class="modal-backdrop" *ngIf="questionDispatchOpen" (click)="closeQuestionDispatchModal()"></div>
  <section class="modal-card cp-modal-fixed-height intranet-question-dispatch-modal" *ngIf="questionDispatchOpen" (click)="$event.stopPropagation()">
    <header class="modal-header">
      <div>
        <h2>{{ 'INTRANET_DASH.QUESTION.TITLE' | translate }}</h2>
        <small>{{ 'INTRANET_DASH.QUESTION.SUBTITLE' | translate }}</small>
      </div>
      <button class="icon" type="button" (click)="closeQuestionDispatchModal()">
        <mat-icon>close</mat-icon>
      </button>
    </header>

    <form class="cp-modal-body" (submit)="$event.preventDefault()">
      <div class="cp-modal-scroll">
        <section class="panel dispatch-section">
          <h3>{{ 'INTRANET_DASH.QUESTION.SURVEY' | translate }}</h3>
          <div class="filter-field compact">
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>{{ 'INTRANET_DASH.QUESTION.SEARCH' | translate }}</mat-label>
              <mat-icon matPrefix>search</mat-icon>
              <input matInput type="text" name="question_survey_search" [(ngModel)]="surveySearch">
            </mat-form-field>
          </div>
          <div class="docs-list" *ngIf="!loadingSurveys; else surveysLoading">
            <label class="doc-item" *ngFor="let survey of filteredIntranetSurveys">
              <input type="radio" name="selectedSurvey" [value]="survey.id" [(ngModel)]="selectedSurveyId">
              <div>
                <strong>{{ survey.title }}</strong>
                <small>{{ 'INTRANET_DASH.QUESTION.STATUS' | translate }}: {{ survey.status | titlecase }}</small>
              </div>
            </label>
            <p class="empty" *ngIf="!filteredIntranetSurveys.length">{{ 'INTRANET_DASH.QUESTION.EMPTY' | translate }}</p>
          </div>
          <ng-template #surveysLoading>
            <p class="list-status">{{ 'INTRANET_DASH.QUESTION.LOADING' | translate }}</p>
          </ng-template>
        </section>

        <section class="panel dispatch-section">
          <h3>{{ 'INTRANET_DASH.QUESTION.RECIPIENTS' | translate }}</h3>
          <div class="source-options">
            <label>
              <input type="radio" name="questionAudience" value="ALL_USERS" [checked]="questionAudience === 'ALL_USERS'" (change)="onQuestionAudienceChange('ALL_USERS')">
              {{ 'INTRANET_DASH.QUESTION.RECIPIENTS_ALL' | translate }}
            </label>
            <label>
              <input type="radio" name="questionAudience" value="SECTOR" [checked]="questionAudience === 'SECTOR'" (change)="onQuestionAudienceChange('SECTOR')">
              {{ 'INTRANET_DASH.QUESTION.RECIPIENTS_SECTOR' | translate }}
            </label>
            <label>
              <input type="radio" name="questionAudience" value="DEPARTMENT" [checked]="questionAudience === 'DEPARTMENT'" (change)="onQuestionAudienceChange('DEPARTMENT')">
              {{ 'INTRANET_DASH.QUESTION.RECIPIENTS_DEPARTMENT' | translate }}
            </label>
            <label>
              <input type="radio" name="questionAudience" value="LOCATION" [checked]="questionAudience === 'LOCATION'" (change)="onQuestionAudienceChange('LOCATION')">
              {{ 'INTRANET_DASH.QUESTION.RECIPIENTS_LOCATION' | translate }}
            </label>
            <label>
              <input type="radio" name="questionAudience" value="SPECIFIC_USERS" [checked]="questionAudience === 'SPECIFIC_USERS'" (change)="onQuestionAudienceChange('SPECIFIC_USERS')">
              {{ 'INTRANET_DASH.QUESTION.RECIPIENTS_SPECIFIC' | translate }}
            </label>
          </div>

          <div class="upload-block" *ngIf="questionAudience === 'SECTOR'">
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>{{ 'INTRANET_DASH.QUESTION.SECTOR' | translate }}</mat-label>
              <select matNativeControl [(ngModel)]="selectedSectorId" name="question_selected_sector" (ngModelChange)="loadQuestionDepartments()">
                <option [ngValue]="null">{{ 'COMMON.SELECT' | translate }}</option>
                <option *ngFor="let sector of questionSectors" [ngValue]="sector.id">{{ sector.name }}</option>
              </select>
            </mat-form-field>
          </div>

          <div class="upload-block" *ngIf="questionAudience === 'DEPARTMENT'">
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>{{ 'INTRANET_DASH.QUESTION.DEPARTMENT' | translate }}</mat-label>
              <select matNativeControl [(ngModel)]="selectedDepartmentId" name="question_selected_department" (ngModelChange)="loadQuestionLocations()">
                <option [ngValue]="null">{{ 'COMMON.SELECT' | translate }}</option>
                <option *ngFor="let dept of questionDepartments" [ngValue]="dept.id">{{ dept.name }}</option>
              </select>
            </mat-form-field>
          </div>

          <div class="upload-block" *ngIf="questionAudience === 'LOCATION'">
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>{{ 'INTRANET_DASH.QUESTION.LOCATION' | translate }}</mat-label>
              <select matNativeControl [(ngModel)]="selectedLocationId" name="question_selected_location">
                <option [ngValue]="null">{{ 'COMMON.SELECT' | translate }}</option>
                <option *ngFor="let loc of questionLocations" [ngValue]="loc.id">{{ loc.name }}</option>
              </select>
            </mat-form-field>
          </div>

          <div *ngIf="questionAudience === 'SPECIFIC_USERS'">
            <div class="filter-field compact">
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>{{ 'INTRANET_DASH.QUESTION.USER_SEARCH' | translate }}</mat-label>
                <mat-icon matPrefix>search</mat-icon>
                <input matInput type="text" name="question_user_search" [(ngModel)]="questionUserSearch">
              </mat-form-field>
            </div>
            <div class="users-list" *ngIf="!loadingRecipients; else questionUsersLoading">
              <label class="user-item" *ngFor="let user of filteredQuestionUsers">
                <input type="checkbox" [checked]="selectedQuestionUserIds.has(user.id)" (change)="toggleQuestionRecipientSelection(user.id)">
                <div>
                  <strong>{{ user.name }}</strong>
                  <small>{{ user.email }}</small>
                </div>
              </label>
              <p class="empty" *ngIf="!filteredQuestionUsers.length">{{ 'INTRANET_DASH.QUESTION.USERS_EMPTY' | translate }}</p>
            </div>
            <ng-template #questionUsersLoading>
              <p class="list-status">{{ 'INTRANET_DASH.QUESTION.USERS_LOADING' | translate }}</p>
            </ng-template>
          </div>
        </section>

        <p class="feedback dispatch-feedback" *ngIf="questionDispatchFeedback" [class.error]="questionDispatchFeedback.includes('não') || questionDispatchFeedback.includes('Selecione')">
          {{ questionDispatchFeedback }}
        </p>
      </div>

      <footer class="entry-footer">
        <button type="button" mat-stroked-button (click)="closeQuestionDispatchModal()">{{ 'COMMON.CANCEL' | translate }}</button>
        <button type="button" mat-raised-button color="primary" (click)="dispatchQuestionnaire()" [disabled]="savingQuestionDispatch">
          {{ savingQuestionDispatch ? ('COMMON.SENDING' | translate) : ('INTRANET_DASH.QUESTION.SEND' | translate) }}
        </button>
      </footer>
    </form>
  </section>
</div>
